import imageUrlBuilder from '@sanity/image-url';

const builder = imageUrlBuilder({
    projectId: "oyf3dba6",
    dataset: "production",
});

export function urlFor(source) {
    return builder.image(source)
}